const auth = 'usr:auth'

const preferences = 'usr:stt'

export default { auth, preferences }
